// Provides field configuration for all fields relating to quotes and products

function optionsField(id, label, product, idx) {
  // Helper method for creating simple droplist fields
  return {
    id: `products[${idx}].input.${id}`,
    label: label,
    type: 'list',
    options: getOptions(product, id)
  }
}
function getOptions(product, id) {
  try {
    let field = product.fields[id]
    if (field.options.length) {
      return field.options
    }
    if (field.max && field.step) {
      let options = []
      for (let i = field.min; i <= field.max; i += field.step) {
        options.push(i)
      }
      return options
    }
    return []
  } catch (e) {
    return []
  }
}

export default {
  name() {
    return [
      {
        id: 'name',
        label: 'QUOTE NAME',
        required: true,
        colspan: 12
      }
    ]
  },

  top() {
    return [
      {
        id: 'name',
        label: 'QUOTE NAME',
        required: true
      },
      {
        id: 'reference',
        label: 'QUOTE ID',
        disabled: true
      },
      {
        label: 'QUOTED BY',
        value(data) {
          let name
          try {
            name = data.external.atmos.user.name // Use our own user name if available
          } catch (e) {
            name = data.user.name // Otherwise use Flexile value
          }
          return `${name.first} ${name.last}`
        }
      },
      {
        label: 'QUOTED FOR',
        value(data) {
          try {
            return data.external.atmos.account.name // Use our own account name if available
          } catch (e) {
            return data.account.name // Otherwise use Flexile value
          }
        }
      }
    ]
  },

  totals() {
    return [
      { heading: 'Pricing summary' },
      {
        id: 'totals.NRC',
        label: 'Total setup',
        disabled: true,
        size: 'large'
      },
      {
        id: 'totals.MRC',
        label: 'Total monthly',
        disabled: true,
        size: 'large'
      },
      {
        label: 'Total contract',
        value(data) {
          // Calculates contract total as NRC + (MRC * TERM) for each product
          try {
            let total = 0
            data.products.forEach(p => {
              let isIpTransitPort = !!p.fields.aDCLocation
              if (!isIpTransitPort) {
                if (
                  p.fields.recurringSellPrice.value === null ||
                  p.fields.oneTimeSellPrice.value === null
                ) {
                  throw 'POA' // Null prices are 'POA', which means the whole total becomes POA
                }
                total =
                  total +
                  p.fields.oneTimeSellPrice.value +
                  p.fields.recurringSellPrice.value * p.fields.term.value
              }
            })
            return (
              '$' +
              total.toLocaleString('en-AU', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            ) // Formats to 2dp with commas
          } catch (e) {
            return 'POA'
          }
        },
        size: 'large'
      },
      {
        heading(data) {
          return data.products.length ? 'Products' : ''
        }
      }
    ]
  },

  location(getOptions) {
    return [
      {
        id: 'input.height',
        label: 'Building height (floors)',
        required: true
      },
      {
        id: 'input.address',
        label: 'Address',
        type: 'autocomplete',
        getOptions,
        required: true,
        colspan: 2
      }
    ]
  },

  productWireless(product, idx) {
    let key = `products[${idx}]`
    let isSwooperfast = product.input.fwType === 'Swooperfast'

    return [
      optionsField('l2L3', 'Service', product, idx),
      optionsField('fwType', 'Type', product, idx),
      optionsField('bandwidth', 'Bandwidth', product, idx),
      optionsField('ipv4Range', 'Subnets', product, idx),
      optionsField('term', 'Term', product, idx),
      {
        id: `${key}.input.swooperfastNrc`,
        label: 'Setup fee',
        type: 'list',
        options: getOptions(product, 'swooperfastNrc'),
        hidden() {
          return !isSwooperfast
        }
      },

      {
        id: `${key}.fields.oneTimeSellPrice.display`,
        label: 'SETUP FEE',
        disabled: true,
        hidden() {
          return isSwooperfast
        }
      },
      {
        id: `${key}.fields.recurringSellPrice.display`,
        label: 'MONTHLY FEE',
        disabled: true
      }
    ]
  },

  productIpTransit(product, idx) {
    let key = `products[${idx}]`
    return [
      optionsField('committedBandwidth', 'Min commit', product, idx),
      optionsField('ratio', 'Burst ratio', product, idx),
      {
        id: `${key}.fields.maxBandwidth.display`,
        label: 'Max bandwidth',
        disabled: true
      },
      optionsField('term', 'Term', product, idx),
      {
        id: `${key}.fields.oneTimeSellPrice.display`,
        label: 'SETUP FEE',
        disabled: true
      },
      {
        id: `${key}.fields.burstRate.display`,
        label: 'Burst fee',
        disabled: true
      },
      {
        id: `${key}.fields.recurringSellPrice.display`,
        label: 'MONTHLY FEE',
        disabled: true
      }
    ]
  },

  productIpTransitPort(product, idx) {
    return [
      optionsField('aDCLocation', 'Location', product, idx),
      optionsField('portSpeed', 'Port speed', product, idx),
      optionsField('maxBandwidth', 'Max bandwidth', product, idx)
    ]
  },

  productOther(product, idx) {
    let key = `products[${idx}]`
    return [
      optionsField('aEndADC', 'A end location', product, idx),
      optionsField('bEndADC', 'B end location', product, idx),
      optionsField('bandwidth', 'Bandwidth', product, idx),
      optionsField('term', 'Term', product, idx),
      {
        id: `${key}.fields.oneTimeSellPrice.display`,
        label: 'SETUP FEE',
        disabled: true
      },
      {
        id: `${key}.fields.recurringSellPrice.display`,
        label: 'MONTHLY FEE',
        disabled: true
      }
    ]
  }
}
